import axios from 'axios';
import { useAuthStore } from '@/store/authStore';

/**
 * Axios instance con interceptor JWT e refresh automatico.
 */
const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 15_000,
});

// Request interceptor — aggiunge Bearer token
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — refresh token automatico su 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      useAuthStore.getState().refreshToken
    ) {
      originalRequest._retry = true;

      try {
        const { data } = await axios.post('/api/v1/auth/refresh', {
          refresh_token: useAuthStore.getState().refreshToken,
        });

        useAuthStore.getState().setAccessToken(data.tokens.access_token);
        originalRequest.headers.Authorization = `Bearer ${data.tokens.access_token}`;

        return api(originalRequest);
      } catch {
        useAuthStore.getState().logout();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  },
);

export default api;
